import { DecimalPipe, NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-artists',
  standalone: true,
  imports: [NgFor, DecimalPipe],
  templateUrl: './artists.component.html',
  styleUrl: './artists.component.scss'
})
export class ArtistsComponent {
  artists = [
    {
      name: 'Stefano Bombardieri',
      quantity: 3
    },
    {
      name: 'Testadichezzo',
      quantity: 1
    },
    {
      name: 'Daed.psd',
      quantity: 1
    },
    {
      name: 'Mars',
      quantity: 1
    },
    {
      name: 'Francesco Scura',
      quantity: 2
    },
    {
      name: 'Bizzarro',
      quantity: 1
    },
    {
      name: 'Ukiyo no Hito',
      quantity: 1
    },
    {
      name: 'Ilaria Merola',
      quantity: 1
    }
  ]
}
